import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input, 
  Output,
  EventEmitter
} from '@angular/core';
import {
  FileUploader, FileItem
} from 'ng2-file-upload';
import { UserDto } from '../../models/User';
import { environment } from '../../../environments/environment';
import {DocumentRef} from '../../models/DocumentRef';
import {Document, PaymentInfo} from '../../models/ApplicationModel';
import {PreviewModalService} from '../services/preview-modal.service';
import { ApplicationService } from '../services/application.service';
import {DocumentDetail} from "../../models/ApplicationDetail";
import {SubDataVariables} from "../../../environments/app.variables";
import { NgxSpinnerService } from 'ngx-spinner';
import {AlertService} from "../services/alert.service";
import {PaymentReciptDoc, FIRItem} from "../../models/CommonModels";
import { FormGroup } from '@angular/forms';
import * as Constants from "../../models/Constants";
import {PaymentInfoDetail} from "../../models/ApplicationDetail";
import { InspectionService } from '../../inspection/shared/services/inspection.service';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '../../services/error-handler.service';
import * as saveAs from 'file-saver';
import { CommonService } from '../services/common.service';
import { from, of, throwError } from 'rxjs';
import { concatMap, mergeMap, toArray } from 'rxjs/operators';
import {
  parseUploadApiError,
  validatePdfFileBeforeUpload
} from '../helpers/pdf-upload-validator';
import {
  isSafeTextInput,
  NO_SCRIPT_INPUT_MESSAGE,
} from '../validators/no-script-input.validator';

// const URL = '/api/';
const URL = environment.baseUrl + '/Attachment';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit, OnChanges {


  @Input() uploader: FileUploader;
  @Input() user: UserDto;
  @Input() documents:Array<Document>;
  @Input() editDocuments:Array<DocumentDetail>;
  @Input() documentRefs: Array<DocumentRef>; 

  @Input() isMultiPaymentUpload: boolean = false;
  @Input() multiPaymentId: string | null = null; 

  @Input() errorMessage: string;
  @Input() isUploadPaymentType : boolean;
  @Input() appID:number;
  @Input() currentPayment:DocumentDetail;
  @Input() currentRecieptNumber:string;
  @Input() payment:string;
  @Input() paymentGroup:FormGroup;
  @Input() paymentInfo: PaymentInfoDetail;
  @Input() smLetterOfExperienceDocRequired: boolean;
  @Input() showPayment: boolean;
  @Input() firDocumentRefs:FIRItem;
  @Input() inspectionID: number;
  @Input() inspectionModule: boolean;
  @Input() isGMPFinalPayment: boolean; // applies only for GMP Inspection in
  @Input() productTypeName: string;
  @Input() seedEditDocumentsOnInit = true;
  

  @Output('uploadPayment') uploadPaymentEvent: EventEmitter<PaymentInfo> = new EventEmitter();
  selRow:number;
  public receiptNumber:string;
  readonly noScriptInputMessage = NO_SCRIPT_INPUT_MESSAGE;
  paymentDocUploaded:boolean;
  referenceId:number;
  submitClickedValue:boolean;
  currentlyUploadedDocId:number;

  documentRefsCopy: Array<DocumentRef>;
  public paymentDocInList: DocumentRef;
  paymentInListIndex:number;
  private paymentModeKey = '';
  paymentData:PaymentInfo;
  paymentDocRefrenceId : number = Constants.PAYMENT_REFERENCE_ID;
  multiPaymentDocReferenceIds: number[] = [Constants.BANK_TRANSFER_SLIP_REFERENCE_ID
    , Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID,Constants.GMP_FINAL_BANK_TRANSFER_SLIP_REFERENCE_ID,
    Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID];

multiplePaymentRefs: DocumentRef[] = [];
   multiUploadedIds: number[] = [];

  constructor(private previewService:PreviewModalService,private applicationService:ApplicationService,
              private spinner: NgxSpinnerService,private alertService: AlertService, private inspectionService: InspectionService,
              private router: Router, private errorHandlerService: ErrorHandlerService, private commonService: CommonService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.documentRefs || changes.isMultiPaymentUpload || changes.isGMPFinalPayment) {
      this.configurePaymentRows();
    }
  }

  ngOnInit() {
    this.configurePaymentRows();

    if (this.showPayment === undefined) {
      this.showPayment = true;
    }
    this.receiptNumber = '';
    this.submitClickedValue = false;
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      form.append('TempFolderName', this.user.username); 
      if(this.inspectionModule){
        form.append('InspectionID', this.inspectionID);
      } else {
        form.append('ApplicationID', this.appID);
      }
      form.append('referenceID', this.referenceId);
      form.append('UserID', this.user.id);
     };
     if(this.currentPayment){
      this.submitClickedValue = true;
      this.receiptNumber =  this.currentRecieptNumber;
      this.currentlyUploadedDocId = this.currentPayment.id;
     }
     if(this.editDocuments ){
      const paymentDocInstance = this.editDocuments.findIndex(doc=> doc.referenceID === this.paymentDocRefrenceId)
       if(paymentDocInstance>-1 && this.paymentInfo)
        this.currentlyUploadedDocId = this.paymentInfo.documentID;
     }  
    
    if(!this.isUploadPaymentType){
      this.paymentInListIndex = this.documentRefs.findIndex(doc=> doc.id === this.paymentDocRefrenceId );
      if(this.paymentInListIndex > -1)
        this.paymentDocInList = this.documentRefs[this.paymentInListIndex];
    } 
    if(this.documents && this.documents.length){
      const paymentDocInstanceInCreate = this.documents.findIndex(doc=> doc.referenceID === this.paymentDocRefrenceId )
       if(paymentDocInstanceInCreate>-1)
        this.currentlyUploadedDocId = this.documents[paymentDocInstanceInCreate].id;
    }

    this.uploader.onErrorItem = (item: FileItem, response: string, status: number) => {
      this.errorMessage = parseUploadApiError(response, status);
      item.isError = true;
      item.isSuccess = false;
    };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => { 
         if(status === 200){
            let parsed;
            try {
              parsed = typeof response === 'string' ? JSON.parse(response) : response;
            } catch {
              this.errorMessage = 'Upload response could not be read.';
              return;
            }
            let doc = new Document(parsed); 
          if (!this.isMultiPaymentUpload && doc.referenceID === this.paymentDocRefrenceId) { 
              this.paymentDocUploaded = true;
              this.currentlyUploadedDocId = doc.id;
              this.currentPayment = new DocumentDetail(parsed);
            }   
            if (this.isMultiPaymentUpload && this.multiPaymentDocReferenceIds.includes(doc.referenceID)) {
              this.recordMultiPaymentUpload(doc);
            }      
                if(this.paymentGroup)
                 this.paymentGroup.controls.receiptNumber && !this.inspectionModule ?  this.receiptNumberAction() : this.uploadPaymentEvent.emit(undefined) 
              
           
            !this.isUploadPaymentType ? this.addToDocumentList(doc) : null;
            
         }
     };

     this.uploader.onAfterAddingFile = (item: FileItem) => {
      item.withCredentials = false;
      const row = this.selRow;
      const maxBytes = this.uploader.options?.maxFileSize;
      validatePdfFileBeforeUpload(item._file, maxBytes).then(validationError => {
        if (validationError) {
          this.errorMessage = validationError;
          item.remove();
          return;
        }

        this.errorMessage = '';
        this.documentRefs[row].fileIndex = this.uploader.getIndexOfItem(item);
        this.referenceId = this.documentRefs[row].id;
        this.uploader.uploadItem(item);
      }).catch(() => {
        this.errorMessage = 'Unable to read the selected file.';
        item.remove();
      });
    };

    if(this.seedEditDocumentsOnInit && this.editDocuments && this.documents.length == 0){
      for(let i=0; i < this.editDocuments.length; i++){
        this.documents.push(new Document(this.editDocuments[i]));
      }
    }
  }

  private configurePaymentRows() {
    const refKey = (this.documentRefs || []).map(doc => doc.id).join(',');
    const modeKey = `${!!this.isMultiPaymentUpload}|${!!this.isGMPFinalPayment}|${refKey}`;
    if (modeKey === this.paymentModeKey) {
      return;
    }
    this.paymentModeKey = modeKey;

    if (this.isMultiPaymentUpload && this.isGMPFinalPayment) {
      this.multiplePaymentRefs = (this.documentRefs || [])
        .filter(doc =>
          doc.id === Constants.GMP_FINAL_BANK_TRANSFER_SLIP_REFERENCE_ID ||
          doc.id === Constants.GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID
        )
        .map(doc => ({
          ...doc,
          receipt: ''
        }));
      return;
    }

    if (this.isMultiPaymentUpload) {
      this.multiplePaymentRefs = (this.documentRefs || [])
        .filter(doc =>
          doc.id === Constants.BANK_TRANSFER_SLIP_REFERENCE_ID ||
          doc.id === Constants.PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID
        )
        .map(doc => ({
          ...doc,
          receipt: ''
        }));
      return;
    }

    this.multiplePaymentRefs = [];
    if (this.isGMPFinalPayment) {
      this.paymentDocRefrenceId = Constants.GMP_FINAL_PAYMENT_REFERENCE_ID;
    }
  }

  receiptNumberAction(){
 
    if(this.currentlyUploadedDocId && this.paymentGroup.controls.receiptNumber){
      const receiptValue = this.paymentGroup.controls.receiptNumber.value;
      if (!isSafeTextInput(receiptValue)) {
        this.paymentGroup.controls.receiptNumber.markAsTouched();
        this.uploadPaymentEvent.emit(undefined);
        return;
      }
      const paymentObject = {
        recieptNumber : receiptValue,
        documentID: this.currentlyUploadedDocId
      }
      //In case of Edit Application, add the paymentInfo Instance ID and applicationID 
      if(this.appID){
        paymentObject['applicationID'] = this.appID;
        paymentObject['id'] = this.paymentInfo?.id;
      }
      this.paymentData = new PaymentInfo(paymentObject);
      this.uploadPaymentEvent.emit(this.paymentData);
    }else
      this.uploadPaymentEvent.emit(undefined)
   }

  isUnsafeReceipt(value: string): boolean {
    return !!value && !isSafeTextInput(value);
  }

  hasUnsafeNgModelReceipts(): boolean {
    if (this.isMultiPaymentUpload) {
      return (this.multiplePaymentRefs || []).some(ref => this.isUnsafeReceipt(ref.receipt));
    }
    return this.isUnsafeReceipt(this.receiptNumber);
  }


  private recordMultiPaymentUpload(doc: Document) {
    const index = this.multiplePaymentRefs.findIndex(d => Number(d.id) === Number(doc.referenceID));
    if (index === -1) {
      return;
    }

    const previousFileId = this.multiplePaymentRefs[index].fileId;
    if (previousFileId) {
      this.multiUploadedIds = this.multiUploadedIds.filter(id => id !== previousFileId);
    }

    this.paymentDocUploaded = true;
    this.multiUploadedIds.push(doc.id);
    this.multiplePaymentRefs[index] = {
      ...this.multiplePaymentRefs[index],
      fileId: doc.id,
      name: doc.filePath ? this.spliceFileName(doc.filePath) : this.multiplePaymentRefs[index].name,
    };
  }

  addToDocumentList(doc:Document){
    if(this.appID && doc.referenceID == this.paymentDocRefrenceId){
     // if it is editing we want only remove the latest payment doc that is edited
      if(this.paymentInfo){
        let index = this.documents.findIndex(d => d.id == this.paymentInfo.documentID);
        if(index !== -1){
          this.documents.splice(index, 1);    
        }
      }
    } else {
      for(var i = this.documents.length-1;i >= 0;i--){

        if(this.documents[i].referenceID === doc.referenceID){
          this.documents.splice(i,1);
        }
      }
    }
    
    this.documents.push(doc);
  }


  selectedRow(rowNumber:number){
    this.selRow = rowNumber;
    this.errorMessage = '';
  }

  openModal(rowNumber:number, referenceId:number){
    if(!this.uploader.queue[this.documentRefs[rowNumber].fileIndex] && this.alreadyUploaded(referenceId)) {
      let docID;
      if(this.currentPaymentDocExists()){

        docID = this.currentPayment.id;

      }
      else{
      var doc = this.editDocuments.find(function (x) {
        return x.referenceID == referenceId
      });

      docID = doc.id;
      
    }
      const attachmentUrl = SubDataVariables.ATTACHMENT_SINGLE_URL + '/' + docID;
      this.previewService.openModal(attachmentUrl, this.documentRefs[rowNumber].name, false);
    } else {
      this.previewService.openModalFile(this.uploader.queue[this.documentRefs[rowNumber].fileIndex]._file, 
          this.uploader.queue[this.documentRefs[rowNumber].fileIndex]._file.name, false);
    }
  }

  alreadyUploaded(referenceId) {
    if(this.documents) {
      var doc = this.documents.find(function (x) {
        return x.referenceID == referenceId
      });
      if(doc) {
        return true
      }
    }
    if (this.editDocuments) {
      var editDoc = this.editDocuments.find(function (x) {
        return x.referenceID == referenceId
      });
      if (editDoc) {
        return true;
      }
    }
    if(this.currentPaymentDocExists()) {
      return true
    }
     if (this.isMultiPaymentUpload && this.uploader?.queue?.length > 0) {
    const docRef = this.documentRefs?.find(d => d.id === referenceId);
    if (docRef && typeof docRef.fileIndex === 'number') {
      const queuedFile = this.uploader.queue[docRef.fileIndex];
      return !!queuedFile;
    }
  }
    return false;
  }

  submitReady(){ 
   if (this.isMultiPaymentUpload) {
    return !!(this.multiplePaymentRefs?.length) && this.multiplePaymentRefs.every(ref =>
      !!ref.fileId
      && !!ref.receipt?.trim()
      && isSafeTextInput(ref.receipt)
    );
  } else { 
    return ((this.paymentDocUploaded || this.currentPaymentDocExists())
      && (this.receiptNumber && this.receiptNumber.length > 0)
      && isSafeTextInput(this.receiptNumber));
  } 
  }

  editClicked(){
    this.submitClickedValue = false;
  }

  submitClicked(){
      if (this.hasUnsafeNgModelReceipts()) {
        this.alertService.error(NO_SCRIPT_INPUT_MESSAGE);
        return;
      }
      this.spinner.show();

 if (this.isMultiPaymentUpload) {
  const validDocs = this.multiplePaymentRefs.filter(d => d.fileId && d.receipt?.trim());

  if (validDocs.length !== this.multiplePaymentRefs.length) {
    this.spinner.hide();
    this.alertService.error('Please upload files and provide a receipt number.');
    return;
  }

  from(validDocs).pipe(
    concatMap(doc => {
      const payload: PaymentReciptDoc = {
        fileID: doc.fileId,
        recieptNumber: doc.receipt.trim(),
        inspectionID: this.inspectionID,
        applicationID: this.appID,
        multiIDs: this.multiUploadedIds,
        isFinalPaymentGMP: this.isGMPFinalPayment
      };
      return this.inspectionService.uploadPaymentInfo(payload).pipe(
        mergeMap(res => !res
          ? throwError({ error: { Message: 'Unable to submit your Payment Document!' } })
          : of(res))
      );
    }),
    toArray()
  ).subscribe({
    next: () => {
      this.spinner.hide();
      this.alertService.success('All multi-payment documents submitted.');
         this.router.navigate(['/inspections/abroadCGMP/list/ABROADCGMP']);
      this.submitClickedValue = true;
    },
    error: err => {
      this.spinner.hide();
      console.error('Multi-upload error:', err);
      this.alertService.error(this.errorHandlerService.handleApiError(err) || 'One or more uploads failed. Please try again.');
    }
  });
}

   else{ let paymentReciptDoc = new PaymentReciptDoc();
    paymentReciptDoc.fileID = this.currentlyUploadedDocId;
    paymentReciptDoc.recieptNumber = this.receiptNumber;

    if(this.appID){
      paymentReciptDoc.applicationID = this.appID;
      this.applicationService.addPaymentRecieptNoToApplication(paymentReciptDoc).subscribe(res=>{
        this.spinner.hide();
        if(res){
          this.alertService.success('Payment Document Submitted Successfully');
          this.submitClickedValue = true;
          this.router.navigate(['applications/all']);
        }
        else{
          this.alertService.error('Unable to submit your Payment Document!');
        }
      },
      err => {
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(err));  
      })
    }

    if(this.inspectionID){
      paymentReciptDoc.inspectionID = this.inspectionID;
      paymentReciptDoc.isFinalPaymentGMP = this.isGMPFinalPayment;
      this.inspectionService.uploadPaymentInfo(paymentReciptDoc).subscribe(res=>{
        this.spinner.hide();
        if(res){
          this.alertService.success('Payment Document Submitted Successfully');
          this.submitClickedValue = true;
          this.router.navigate(['/inspections/abroadCGMP/list/ABROADCGMP']);// only abroad cgmp has payment upload
        }
        else{
          this.alertService.error('Unable to submit your Payment Document!');
        }
      },
      err => {
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(err));  
      })
    } 
  }   
  }

  getFileName(doc:DocumentRef){
    
    if(doc.fileIndex || doc.fileIndex === 0){
      if(this.uploader.queue[doc.fileIndex]){
        return this.uploader.queue[doc.fileIndex].file.name;
      }     
    }

    if(this.currentPayment && this.currentPayment.referenceID === doc.id){

      return this.spliceFileName(this.currentPayment.filePath);

    }

    if(!this.editDocuments){
      return "";
   }

    if(doc.id !== Constants.PAYMENT_REFERENCE_ID)
    {
      var editDoc = this.editDocuments.find(function (x) {
        return x.referenceID == doc.id;
      });
    } else 
    {
      let that = this;
      if(that.paymentInfo){
        var editDoc = this.editDocuments.find(function (x) {
          return x.id == that.paymentInfo.documentID;
        });
      }
    }
    

    if(editDoc){
      return this.spliceFileName(editDoc.filePath);
    }

    return "";

  }

  getProgress(doc:DocumentRef){
    if(doc.fileIndex || doc.fileIndex === 0){
      if(this.uploader.queue[doc.fileIndex]){
        return this.uploader.queue[doc.fileIndex].progress;
      }    
    }

    if(this.currentPayment && this.currentPayment.id === doc.id){
      return 100;
    }

    if(!this.editDocuments){
       return 0;
    }

    var editDoc = this.editDocuments.find(function (x) {
      return x.referenceID == doc.id;
    });

    if(editDoc){
      return 100;
    }

    return 0;
  }

  currentPaymentDocExists(){

     if(this.currentPayment){
       return true;
     }

     return false;
  }

  spliceFileName(filePath:string) {

    let fileName =filePath.replace(/^.*[\\\/]/, '');
    if (!fileName.length) fileName = '-';
 
      return fileName;
    }

  isDocumentRequired(doc){
    if(doc.name === Constants.EXPERIENCE_LETTER_STORE_MANAGER_DOC && doc.required){
      return this.smLetterOfExperienceDocRequired;
    } 
    return doc.required;
  }

  uploadDisabled(index) {
    if (this.firDocumentRefs === undefined){
      return false;
    }

     if (!this.firDocumentRefs) {
       return true;
     } else {
          if (this.documents.findIndex(d => d.referenceID === this.documentRefs[index].id) === -1 && this.documentRefs[index].required){
            return false;
          } else {
            return this.firDocumentRefs.subItems.findIndex(item => item.name === this.documentRefs[index].name) === -1;
          }
     }
  }

  fieldHighlighted(index) {
    return { 'input-highlight': this.firDocumentRefs && !this.uploadDisabled(index) };
  }

  downloadFile(){
    this.spinner.show();
    let docName = this.productTypeName == Constants.PRODUCT_TYPE_FOOD ? "ConsentForm_Food" : "ConsentForm_Medicine"; 
    this.commonService.getSystemFile(Constants.CONSENT_FORM_DOC, `${docName}.pdf`).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        const name = 'Consent Form.pdf'
        const blob = new Blob([resp], {
          type: 'application/pdf'
        });
        saveAs(blob, name);
        this.alertService.success("Consent Form downloaded successfully!");
      }else{
        this.alertService.error("Consent Form could not be downloaded!");
      }
    }, err =>{
      this.spinner.hide();
      console.log(err);
      this.alertService.error("Consent Form form could not be downloaded!");
    })
  }
}
